/**
 * CascadeSummaryBar — 5-column KPI strip for cascade simulation results
 */

interface CascadeSummaryBarProps {
  summary: {
    assetsLost: number
    totalUnitsLost: number
    assetsImpacted: number
    avgCapacityDelta: number
    threatEscalations: number
    missionsDenied: number
  }
}

export function CascadeSummaryBar({ summary }: CascadeSummaryBarProps) {
  const stats = [
    {
      label: 'LOSSES',
      value: `${summary.assetsLost}`,
      subline: `${summary.totalUnitsLost} unit${summary.totalUnitsLost !== 1 ? 's' : ''} / ${summary.assetsLost} type${summary.assetsLost !== 1 ? 's' : ''}`,
      color: 'text-red-400',
      bg: 'bg-red-500/10 border-red-500/30',
    },
    {
      label: 'IMPACTED',
      value: summary.assetsImpacted,
      subline: null,
      color: 'text-amber-400',
      bg: 'bg-amber-500/10 border-amber-500/30',
    },
    {
      label: 'AVG CAP Δ',
      value: `${summary.avgCapacityDelta > 0 ? '+' : ''}${summary.avgCapacityDelta.toFixed(1)}%`,
      subline: null,
      color: summary.avgCapacityDelta < -10 ? 'text-red-400' : summary.avgCapacityDelta < 0 ? 'text-amber-400' : 'text-term-text',
      bg: summary.avgCapacityDelta < -10 ? 'bg-red-500/10 border-red-500/30' : 'bg-term-bgLight border-term-border',
    },
    {
      label: 'ESCALATIONS',
      value: summary.threatEscalations,
      subline: null,
      color: summary.threatEscalations > 0 ? 'text-red-400' : 'text-term-text',
      bg: summary.threatEscalations > 0 ? 'bg-red-500/10 border-red-500/30' : 'bg-term-bgLight border-term-border',
    },
    {
      label: 'MISSIONS DENIED',
      value: summary.missionsDenied,
      subline: null,
      color: summary.missionsDenied > 0 ? 'text-red-400' : 'text-term-text',
      bg: summary.missionsDenied > 0 ? 'bg-red-500/10 border-red-500/30' : 'bg-term-bgLight border-term-border',
    },
  ]

  return (
    <div className="grid grid-cols-5 gap-2">
      {stats.map(s => (
        <div key={s.label} className={`term-box p-2.5 text-center border ${s.bg}`}>
          <div className={`text-lg font-bold tabular-nums ${s.color}`}>
            {s.value}
          </div>
          <div className="text-[9px] text-term-textDim font-bold uppercase tracking-wider mt-0.5">
            {s.label}
          </div>
          {s.subline && (
            <div className="text-[8px] text-term-textDim mt-0.5">
              {s.subline}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
